import React from "react";
import GenericUploadStatusBar from "./GenericUploadStatusBar";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { getStore } from "src/store/storeRef";
import ThemeProvider from "src/theming/ThemeProvider";
import { I18nextProvider } from "react-i18next";
import i18next from "src/i18n";

const beforeUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    return '';
}

export interface GenericBulkUploadConfig {
    heading: string;
    data: any[];
    apiCallFn: (requestData: any) => Promise<any>;
    getRequestBody: (batchData: any[]) => any;
    failureArrayKeysToShow: string[];
    isSingleApi?: boolean;
    onAllBatchesComplete?: () => Promise<any>;
    dataHeaders: any[];
    requestMetadata?: Record<string, any>;
    concurrencyLimit?: number;
    batchSize?: number;
    jobCompleteMessage?: string;
    zIndexToUse?: number;
    downloadAllResults?: boolean;
}

const isValidDataItem = (item: any): boolean => {
    if (item === null || item === undefined) return false;
    if (typeof item === 'string') return item.trim().length > 0;
    if (typeof item === 'number') return !isNaN(item);
    if (typeof item === 'object') return Object.keys(item).length > 0;
    return false;
};

const uploadData = (config: GenericBulkUploadConfig) => {
    const store = getStore();
    const containerElement = document.getElementById('generic-bulk-upload-service-container');
    if (containerElement && containerElement.children.length === 0) {
        const filteredData = config.data.filter(isValidDataItem);
        if (config.data?.length) {
            ReactDOM.render(
                <Provider store={store}>
                    <ThemeProvider>
                        <I18nextProvider i18n={i18next}>
                            <GenericUploadStatusBar
                                heading={config.heading}
                                apiCallFn={config.apiCallFn}
                                data={filteredData}
                                getRequestBody={config.getRequestBody}
                                onCompletion={() => {
                                    window.removeEventListener('beforeunload', beforeUnload);
                                    ReactDOM.unmountComponentAtNode(containerElement);
                                }}
                                failureArrayKeysToShow={config.failureArrayKeysToShow}
                                isSingleApi={config.isSingleApi}
                                onAllBatchesComplete={config.onAllBatchesComplete}
                                dataHeaders={config.dataHeaders}
                                requestMetadata={config.requestMetadata}
                                concurrencyLimit={config.concurrencyLimit}
                                batchSize={config.batchSize}
                                jobCompleteMessage={config.jobCompleteMessage}
                                zIndexToUse={config.zIndexToUse}
                                downloadAllResults={config.downloadAllResults}
                            />
                        </I18nextProvider>
                    </ThemeProvider>
                </Provider>,
                containerElement,
            );

            window.addEventListener('beforeunload', beforeUnload);

        } else {
            throw new Error('No data to upload.');
        }
    } else {
        throw new Error('An upload is already in progress, please wait for it to complete and close the dialog before starting a new one.');
    }
};

export const GenericBulkUploadService = {
  uploadData,
};

export default GenericBulkUploadService;
